import React from "react";
import Header from "./components/Header/Header";
import Body from "./components/Body/Body";

const App = () => {
  return (
    <>
      <Header />
      <Body />
    </>
  );
};

export default App;
